import React from "react";
import { Box, List, ListItem, ListItemAvatar, ListItemText, Divider, makeStyles, createStyles } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import withAuthority from "../../../../../components/Auth/withAuthority";
import Authorities from "../../../../../auth/authorities";
import { CustomTheme } from "../../../../../types/customTheme";

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    container: {
      padding: "16px 24px",
      marginTop: "18px",
    },
    headerButton: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "16px",
    },
    addButtonSkeleton: {
      width: "150px",
      height: "36px",
      borderRadius: "10px",
    },
    listContainer: {
      backgroundColor: theme.palette.background.entity_background,
      borderRadius: "12px",
      overflow: "hidden",
    },
    listItem: {
      padding: "16px 24px",
      backgroundColor: theme.palette.background.entity_background,
    },
    avatarSkeleton: {
      width: 60,
      height: 60,
      borderRadius: "10px",
      marginRight: "16px",
    },
    itemContent: {
      flex: 1,
    },
    titleSkeleton: {
      width: "200px",
      height: "28px",
      marginBottom: "4px",
    },
    descriptionSkeleton: {
      width: "300px",
      height: "20px",
      marginBottom: "8px",
    },
    statsContainer: {
      display: "flex",
      gap: "12px",
      marginTop: "4px",
    },
    statSkeleton: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
    },
    buttonContainer: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
    },
    viewButtonSkeleton: {
      width: "80px",
      height: "34px",
      borderRadius: "10px",
    },
    actionButtonSkeleton: {
      width: "80px",
      height: "34px",
      borderRadius: "10px",
    },
    divider: {
      backgroundColor: theme.palette.background.entity_border,
    },
  })
);

const MenuListSkeletonLoading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {/* Header with Add Button */}
      <Box className={classes.headerButton}>
        <Skeleton variant="rect" className={classes.addButtonSkeleton} />
      </Box>

      {/* List Container */}
      <Box className={classes.listContainer}>
        {[1, 2, 3, 4, 5].map((item, index) => (
          <React.Fragment key={item}>
            {index > 0 && <Divider className={classes.divider} />}
            <ListItem className={classes.listItem}>
              {/* Avatar / Image Skeleton */}
              <ListItemAvatar>
                <Skeleton variant="rect" className={classes.avatarSkeleton} />
              </ListItemAvatar>

              {/* Content Skeleton */}
              <ListItemText
                className={classes.itemContent}
                primary={<Skeleton variant="text" className={classes.titleSkeleton} />}
                secondary={
                  <Box>
                    {/* Description Skeleton */}
                    <Skeleton variant="text" className={classes.descriptionSkeleton} />
                    
                    {/* Stats Section Skeleton */}
                    <Box className={classes.statsContainer}>
                      <Box className={classes.statSkeleton}>
                        <Skeleton variant="circle" width={14} height={14} />
                        <Skeleton variant="text" width={80} height={16} />
                      </Box>
                      <Box className={classes.statSkeleton}>
                        <Skeleton variant="circle" width={14} height={14} />
                        <Skeleton variant="text" width={70} height={16} />
                      </Box>
                    </Box>
                  </Box>
                }
              />

              {/* Action Buttons Skeleton */}
              <Box className={classes.buttonContainer}>
                <Skeleton variant="rect" className={classes.viewButtonSkeleton} />
                <Skeleton variant="rect" className={classes.actionButtonSkeleton} />
              </Box>
            </ListItem>
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default withAuthority(MenuListSkeletonLoading, Authorities.DASHBOARD_READ);